import React, { FC, useMemo } from 'react';
import { RateTypes } from '../../../../../../enum/RateTypes';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';
import Rate from '../../../../../presentational/financeElements/rate/Rate';

const TermInYearsContainer: FC = () => {
  const duration: number = useSelector(currentDealSelectors.getFinanceQuoteDuration);
  const durationInYears = useMemo(() => (typeof duration === 'number' ? +duration / 12 : 0), [duration]);

  return <Rate labelId={RateTypes.PAYMENT_TERM} value={`${durationInYears}`} />;
};

export default TermInYearsContainer;
